import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { TravelFormCtaV1Attributes, TravelFormCtaV1Meta } from '@/features/travel-form/travel-form-cta-v1-type';

import React from 'react';

import dynamic from 'next/dynamic';

import useTravelFormCta, { useTravelFormSubmitLoading } from '@/features/travel-form/travel-form-state';
import { useResetDestinationListener } from '@/features/travel-form/use-reset-destination-listener';

const TravelFormCollapsed = dynamic(
    /* webpackChunkName: "TravelFormCollapsed" */ () =>
        import('@/features/travel-form/travel-form-collapsed/travel-form-collapsed'),
);

const TravelFormCollapsedExploitHeader = dynamic(
    /* webpackChunkName: "TravelFormCollapsed" */ () =>
        import('@/features/travel-form/travel-form-collapsed/travel-form-collapsed-exploit-header'),
);

const TravelFormOverlayContainer = dynamic(
    /* webpackChunkName: "TravelFormOverlayContainer" */ () =>
        import('@/features/travel-form/travel-form-overlay/travel-form-overlay-container'),
);

export type TravelFormCtaV1Props = PageComponentProps<TravelFormCtaV1Attributes, TravelFormCtaV1Meta>;

export default function TravelFormCtaV1({
    attributes: { ctaText, hasFilter, subtitle, title },
    componentId,
    isPageLoading,
    meta,
}: TravelFormCtaV1Props) {
    const { collapseTravelForm, isTravelFormExpanded, onTravelFormLoaded } = useTravelFormCta();
    const { setTravelFormSubmitLoading } = useTravelFormSubmitLoading();
    useResetDestinationListener();

    const onSubmitClick = () => {
        collapseTravelForm();
        setTravelFormSubmitLoading(true);
    };

    return (
        <>
            {meta?.display === 'exploit_header' ? (
                <TravelFormCollapsedExploitHeader
                    componentId={componentId}
                    ctaText={ctaText}
                    fullWidth={true}
                    hasFilter={hasFilter}
                    isPageLoading={isPageLoading}
                    isSticky={meta.position === 'sticky'}
                    loadingStateHandling={'auto'}
                    subtitle={subtitle}
                    title={title}
                />
            ) : (
                <TravelFormCollapsed
                    ctaText={ctaText}
                    fullWidth={true}
                    isPageLoading={isPageLoading}
                    isSticky={meta.position === 'sticky'}
                    loadingStateHandling={'auto'}
                    subtitle={subtitle}
                    title={title}
                />
            )}
            {isTravelFormExpanded && (
                <TravelFormOverlayContainer
                    onBackdropClick={collapseTravelForm}
                    onSubmitClick={onSubmitClick}
                    onTravelFormLoaded={onTravelFormLoaded}
                />
            )}
        </>
    );
}
